import resum1 from "../image/resum1.webp";
import resume2 from "../image/resume2.webp";
import resume3 from "../image/resume3.webp";
import resume4 from "../image/resume4.webp";
import resume6 from "../image/resume6.webp";
import resume7 from "../image/resume7.webp";
import resume8 from "../image/resume8.webp";
import resume9 from "../image/resume9.webp";
import resume10 from "../image/resume10.webp";
import resume11 from "../image/resume11.webp";
import resume12 from "../image/resume12.webp";
import resume13 from "../image/resume13.webp";
import resume14 from "../image/resume14.webp";

export const resumeImages = [
  {
    id: 1,
    src: resum1,
    alt: "Professional Resume Template 1",
    description: "Professional and elegant resume template with a timeline structure",
  },
  {
    id: 2,
    src: resume2,
    alt: "Modern Resume Design 2",
    description: "Clean and modern resume portfolio or cv template",
  },
  {
    id: 3,
    src: resume3,
    alt: "Creative Resume Layout 3",
    description: "This Marketing Manager resume template is designed to easily pass the computer screenings.",
  },
  { id: 4, src: resume4, alt: "Elegant Resume Example 4" },
  { id: 6, src: resume6, alt: "Corporate Resume Format 6" },
  { id: 7, src: resume7, alt: "Academic Resume Sample 7" },
  { id: 8, src: resume8, alt: "Infographic Resume Design 8" },
  { id: 9, src: resume9, alt: "Simple Resume Template 9" },
  { id: 10, src: resume10, alt: "Stylish Resume Example 10" },
  { id: 11, src: resume11, alt: "Functional Resume Format 11" },
  { id: 12, src: resume12, alt: "Colorful Resume Design 12" },
  { id: 13, src: resume13, alt: "Executive Resume Template 13" },
  { id: 14, src: resume14, alt: "Digital Resume Layout 14" },
];